<template>
  <div class="register-page">
    <Header class="register-page__header"></Header>
    <Progress class="register-page__progress"></Progress>
    <!-- <div class="test-selector">
      
      <button @click="testSelectorClear">clear</button>
      <CustomSelector
          class="procedural-form__custom-selector"
          label="title"
          title="*TITLE"
          :options="titleOptions"
          v-model="title.value"
          :closeIfLeft="true"
          :is-valid="title.isValid"
          @selected="title.isValid=true"ooooo
      ></CustomSelector>
    </div>-->
    <Form class="register-page__form" :email="registerEmail" :step="registerStep" :attempt="registerAttempt"
      @started="started" @register="register" @onError="onFormError"></Form>
    <Footer class="register-page__footer"></Footer>

    <Modal v-if="showDialog" @close="showDialog = false" dialogStyle="login-modal">
      <template #header>
        <h3> {{ $t("register.login") }}</h3>
      </template>
      <template #body>
        <p>{{ dialogMessage }}</p>
      </template>
      <template #footer>
        <button @click="showDialog = false">{{ $t("register.ok") }}</button>
      </template>
    </Modal>

    <Modal class="forgot-dialog" v-if="showForgotDialog" @close="showForgotDialog = false" dialogStyle="login-modal">
      <template v-slot:header>
        <h3>{{ $t("register.login") }}</h3>
      </template>
      <template v-slot:body>
        <div>
          <p>{{ dialogMessage }}</p>
          <input type="number" v-model="forgotCode" />
          <input type="password" v-model="newPass1" />
          <input type="password" v-model="newPass2" />
        </div>
      </template>
      <template v-slot:footer>
        <button @click="submitNewPassword">{{ $t("register.chenge") }}</button>
      </template>
    </Modal>

    <Modal class="totp-dialog" v-if="showTOTPDialog" @close="showTOTPDialog = false" dialogStyle="login-modal">
      <template v-slot:header>
        <h3>{{ $t("register.login") }}</h3>
      </template>
      <template v-slot:body>
        <div>
          <p>{{ dialogMessage }}</p>
          <input type="number" v-model="totpCode" />
        </div>
      </template>
      <template v-slot:footer>
        <button @click="totpLogin">{{ $t("register.yes") }}</button>
      </template>
    </Modal>

    <Modal class="forgot-dialog" v-if="showCodeDialog" dialogStyle="login-modal">
      <template v-slot:header>
        <h3>{{ $t("register.login") }}</h3>
      </template>
      <template v-slot:body>
        <div>
          <p>{{ dialogMessage }}</p>
          <p>{{ dialogMessage2 }}</p>
          <p v-if="dialogErrorMesssage" style="color: red;">{{ dialogErrorMesssage }}</p>
          <input type="password" v-model="newCode" maxlength="6" />
        </div>
      </template>
      <template v-slot:footer>
        <button class="btn-gray-modal" @click="submitRequestNewCode">{{ $t("register.sendCode") }}</button>
        <button class="btn-black-modal" @click="submitNewCode">{{ $t("register.submit") }}</button>
      </template>
    </Modal>

    <Preloader :showModal="showM"></Preloader>
  </div>
</template>

<script>
import { Logger } from 'aws-amplify'
import Modal from "@/components/Modal"

import { getCurrentInstance, onMounted, onUnmounted, ref } from "@vue/runtime-core"
import Footer from "@/components/login/Footer";
import Header from "@/components/login/Header";
import Progress from "@/components/login/Progress";
import Form from "@/components/login/Form";
import { i18n } from "@/plugins/i18n";
import store from "@/store"
import router from "@/router"
import { useRoute } from 'vue-router'
import { getApplicationsByEmail } from "../../plugins/authUtils";
import axios from "axios";
import Preloader from "@/components/Preloader";
// import CustomSelector from "../../components/CustomSelectorWhite";
import {
  TITLE,
} from "@/plugins/countries"


const logger = new Logger("main")

export default {
  created() {
    document.title = i18n.global.t("register.accountRe") + process.env.VUE_APP_CABINET_V2_WEBSITE_NAME;
    document.getElementsByTagName('meta')["description"].content = i18n.global.t("register.description");
  },
  name: "Register",
  components: {
    // LoginHeader,
    // LoginBox,
    Modal,
    Header,
    Progress,
    Form,
    Footer,
    Preloader,
    // CustomSelector,
  },
  setup() {
    const titleOptions = TITLE
    let title = ref({
      value: null,
      isValid: false
    })

    let showM = ref(false);
    let dialogMessage = ref(null)
    let dialogMessage2 = ref(null)
    let dialogErrorMesssage = ref(null)
    let showDialog = ref(false)
    let showForgotDialog = ref(false)
    let showTOTPDialog = ref(false)
    let showCodeDialog = ref(false)
    let totpCode = ref(null)
    let forgotCode = ref(null)
    let newPass1 = ref(null)
    let newPass2 = ref(null)
    let newCode = ref(null)
    let user = ref(null)
    let authUser = ref(null)
    let forgotEmail = ref(null)
    let registerStep = ref(1)
    let registerEmail = ref(null)
    let registerFirstName = ref(null)
    let registerLastName = ref(null)
    let registerAttempt = ref(0)
    let attemptedEmail = ref(null)

    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    const loginBox = ref(null)

    let currentPassword

    const route = useRoute()

    onMounted(() => {

      store.commit('setLoginFlow', 'REGISTER')
      currentPassword = null
      emitter.on("authStateUpdated", (args) => {
        switch (args.state) {
          case 'REGISTERED':
            attemptedEmail.value = args.email
            emitter.emit('showCodeDialog', i18n.global.t("register.codeDialog"))
            emitter.emit('showCodeDialog2', i18n.global.t("register.codeDialogTwo"))
            break
        }
      })
      emitter.on('showDialog', (message) => {
        dialogMessage.value = message
        showDialog.value = true
      })
      emitter.on('showDialog2', (message) => {
        dialogMessage.value = message
        showDialog.value = true
      })
      emitter.on('closeAllRegisterDialogs', () => {
        showDialog.value = false
        showCodeDialog.value = false
      })
      emitter.on('showCodeDialog', (message) => {
        dialogMessage.value = message
        dialogErrorMesssage.value = null
        showCodeDialog.value = true
      })
      emitter.on('showCodeDialog2', (message) => {
        dialogMessage2.value = message
        dialogErrorMesssage.value = null
        showCodeDialog.value = true
      })
      emitter.on('showCodeDialogErrorMessage', (message) => {
        dialogErrorMesssage.value = message
      })
      emitter.on("userSet", () => {
        registerStep.value = 2
        if (store.state.user !== null) {
          registerEmail.value = store.state.user.email
        }
        else {
          router.replace('/register/2/' + localStorage.getItem('typeAccount')).catch(error => {
            logger.error(error)
          })
        }
      })

      localStorage.setItem('typeAccount', route.params.account)
      switch (route.params.id) {
        case '3':
          emitter.emit('requestSignOut')
          break
        case '2':
          registerStep.value = 2
          if (store.state.user !== null) {
            if (route.params.account === 'live-account' && route.params.account === 'demo-account') {
              registerEmail.value = store.state.user.email
            }
          }
          break
        case '1':
          if (route.params.account !== 'live-account' && route.params.account !== 'demo-account') {
            store.commit('setTypeAccount', route.params.account)
            localStorage.setItem('typeAccount', store.state.typeAccount)
              .catch(error => {
                logger.error(error)
              })
          } else {
            store.commit('setTypeAccount', route.params.account)
          }
          break
        default:
          registerStep.value = 1
          break
      }
    })

    onUnmounted(() => {
      emitter.off("authStateUpdated")
      emitter.off("userSet")
      emitter.off('closeAllRegisterDialogs')
      emitter.off('showDialog')
      emitter.off('showCodeDialog')
      emitter.off('showCodeDialogErrorMessage')
    })

    const started = async (email, password, disclaimer) => {
      currentPassword = password
      emitter.emit('requestSignUp', {
        email: email,
        password: password,
        disclaimer: disclaimer
      })
    }

    const register = (email, firstName, lastName, accountType, disclaimer) => {
      disclaimer = true;
      if (store.state.user !== null) {
        let applicationProcess
        createApplicationProcess(store.state.user.email, accountType, disclaimer)
          .then((appProcess) => {
            applicationProcess = appProcess
            return registerUserInitialStepV2(store.state.user.email, accountType, firstName, lastName, applicationProcess.id, disclaimer)
          })
          .then((result) => {
            return getApplicationsByEmail(email, applicationProcess.id)
          })
          .then((result) => {
            store.commit('setApplication', applicationProcess)
            emitter.emit('applicationUpdated')
            emitter.emit('doAuthenticatedUser', store.state.user.email)

            // //  TODO: should be refactored out of here!
            // router.replace('/cabinet/console/applications').catch(error => {
            //   logger.error(error)
            // })
          })
          .catch((error) => {
            logger.error(error)
          })
      } else {
        logger.error('userInfo is null')
      }
    }

    const createApplicationProcess = (email, accountType, disclaimer) => {
      return new Promise(((resolve, reject) => {

        showM.value = true
        let _url = process.env.VUE_APP_CABINET_V2_API_HOST_ACCOUNTS + '/create/demo-account'
        console.log("URL : ", _url);
        let _headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + store.state.token,
          //'X-Referrer': 'register',
          'X-Api-Key': process.env.VUE_APP_X_API_KEY
        }
        let _data = {
          applicationType: accountType,
          disclaimer: disclaimer,
        }

        axios({ method: 'POST', url: _url, data: _data, headers: _headers }).then((result) => {
          let application = result.data
          if (application !== null) {
            showM.value = false
            resolve(application)
            console.log("Respuesta - ", application)

          } else {
            logger.error(i18n.global.t("register.errorEight"))
            reject('ERROR: unable to update the application record')
          }
        }).catch((error) => {
          logger.error(error)
          reject(error)
        })
      }))
    }

    const registerUserInitialStepV2 = (email, accountType, firstName, lastName, appID, disclaimer) => {
      return new Promise(((resolve, reject) => {
        showM.value = true

        let _url = process.env.VUE_APP_CABINET_V2_API_HOST_USER + '/user/initial'
        let _headers = {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + store.state.token,
          //'X-Referrer': 'register',
          'X-Api-Key': process.env.VUE_APP_X_API_KEY
        }
        let _data = {
          firstName: firstName,
          lastName: lastName,
          country: 'US',
          accountType: accountType,
          applicationID: appID,
          disclaimer: disclaimer
        }

        axios({ method: 'POST', url: _url, data: _data, headers: _headers }).then((result) => {
          let data = result.data
          let user = data.user
          store.commit('updateUser', user)
          resolve(user)
          showM.value = false
        })
          .catch((error) => {
            logger.error(error)
            reject(error)
          })
      }))
    }

    const onFormError = async (title, body) => {
      console.log(body)
      emitter.emit('showDialog', body)
    }

    //  ----------------------------------------------

    const confirmUser = async () => {
      showCodeDialog.value = false
      emitter.emit('requestConfirmSignUp', {
        email: attemptedEmail.value,
        newCode: newCode.value
      })
    }

    const submitNewCode = async () => {
      if (currentPassword !== null) {
        emitter.emit('requestConfirmSignUpAndLogin', {
          email: attemptedEmail.value,
          newCode: newCode.value,
          password: currentPassword
        })
      } else {
        emitter.emit('requestConfirmSignUp', {
          email: attemptedEmail.value,
          newCode: newCode.value
        })
      }
    }

    const submitRequestNewCode = () => {
      newCode.value = null
      dialogErrorMesssage.value = null
      emitter.emit('requestNewCode', {
        email: attemptedEmail.value
      })
    }

    const testSelectorClear = () => {
      title.value = {
        value: null,
        isValid: false
      }
    }

    return {
      loginBox,
      submitRequestNewCode,
      started,
      register,
      onFormError,
      confirmUser,
      submitNewCode,
      dialogMessage,
      dialogMessage2,
      dialogErrorMesssage,
      showDialog,
      showForgotDialog,
      showTOTPDialog,
      showCodeDialog,
      totpCode,
      forgotCode,
      newPass1,
      newPass2,
      newCode,
      user,
      authUser,
      forgotEmail,
      registerStep,
      registerEmail,
      registerFirstName,
      registerLastName,
      registerAttempt,
      attemptedEmail,
      showM,

      title,
      titleOptions,
      testSelectorClear,
    }
  }
}
</script>

<style scoped lang="scss">
.test-selector {
  max-width: 300px;
  position: absolute;
  top: 800px;
  left: 100px;
}

.modal-body p {
  text-align: left;
}

.register-page__footer .register-footer.mobile {
  width: 100% !important;
}
</style>
